import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-account-credit-pmt-dialog",
  templateUrl: "./account-credit-pmt-dialog.component.html",
  styleUrls: ["./account-credit-pmt-dialog.component.scss"]
})
export class AccountCreditPmtDialogComponent implements OnInit
{

  constructor(
    public dialogRef: MatDialogRef<AccountCreditPmtDialogComponent>
  ) { }

  ngOnInit(): void
  {

  }

}
